import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { ComponentMultipleChoice } from '../component.constants';
import type { Pluck } from 'lib/gql/pluck';

type BaseProps = Omit<ComponentMultipleChoice, '__typename'>;
export type ViewProps = BaseProps;
export type EditProps = ViewProps;
export type PrintProps = BaseProps;

export type MultipleChoiceProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesMultipleChoiceComponent' }
  >,
  'properties'
>;
export type MultipleChoiceOption = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesMultipleChoiceComponent' }
  >,
  'properties.multipleChoice.options'
>;
export type MultipleChoiceCropData = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesMultipleChoiceComponent' }
  >,
  'properties.multipleChoice.options.cropData'
>;
export type MultipleChoiceImage = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesMultipleChoiceComponent' }
  >,
  'properties.multipleChoice.options.image'
>;

export const ANSWER_LABELS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const CORRECT = 'correct';
export const INCORRECT = 'incorrect';
